import axios from 'axios';
import { showAtlasPresentationBuilder } from 'src/utils/app';
import {
  GenerateReportFromAPIRequest,
  GenerateReportFromAPIResponse,
  PresentationsDownloadListResponse
} from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';

export { checkCreditBalance } from 'src/utils/creditsApi';
export type { BalanceCheckResponse } from 'src/utils/creditsApi';

export const generateReport = async (body) => {
  const response = await axios.post('/api/stories/report', body);
  return response.data;
};

export const generateReportFromAPI = async (body: GenerateReportFromAPIRequest): Promise<GenerateReportFromAPIResponse> => {
  const response = await axios.post<GenerateReportFromAPIResponse>('/api/stories/v2/report', body);
  return response.data;
};

export const presentationsDownloadServerProxy = (page_size: number) => {
  return {
    fetchPresentationsList: async (paginationToken: string): Promise<PresentationsDownloadListResponse> => {
      const response = await axios.get<PresentationsDownloadListResponse>('/api/stories/v2/reports', {
        params: {
          page_size,
          last_key: paginationToken
        }
      });
      return response.data;
    }
  };
};

export const getPresentationsQuota = async () => {
  const response = await axios.get('/api/stories/quota');
  return response.data;
};

export const getPresentations = async () => {
  if (!showAtlasPresentationBuilder()) {
    return [];
  }
  const response = await axios.get('/api/presentations');
  return response.data;
};

export const getPresentationsByVendor = async (vendorId: string) => {
  if (!showAtlasPresentationBuilder()) {
    return [];
  }

  const response = await axios.get(`/api/presentations/vendor/${vendorId}`);
  return response.data;
};
